<dx-diagram *ngIf="taggedItemsTypes?.length" #diagram id="diagram" class="custom-shape-svg"
    [customShapeTemplate]="'customShapeTemplate'" (onRequestEditOperation)="requestEditOperationHandler($event)"
    (onItemDrop)="onItemDrop($event)">
    <dxi-custom-shape *ngFor="let tmp of taggedItemsTypes" category="taggedItemsTypes" [type]="tmp.name"
        baseType="rectangle" [defaultText]="tmp.name" [allowEditText]="false" [defaultWidth]="1.3" [defaultHeight]="0.5"
        [description]="tmp.description">
    </dxi-custom-shape>
    <!-- [defaultImageUrl]="getIcon(tmp)" -->
    <!-- <dxi-custom-shape
        category="taggedItemsTypes"
        [type]="customItem.name"
        baseType="rectangle"
        [defaultText]="customItem.name"
        [defaultImageUrl]="customItem.icon"
        [allowEditText]="true"
        [defaultWidth]="1.3"
        [defaultHeight]="0.5"
    >
    </dxi-custom-shape> -->

    <dxo-main-toolbar [visible]="false"></dxo-main-toolbar>
    <dxo-history-toolbar [visible]="false"></dxo-history-toolbar>
    <dxo-view-toolbar [visible]="false"></dxo-view-toolbar>

    <dxo-properties-panel [visibility]="'disabled'"></dxo-properties-panel>

    <dxo-toolbox>
        <dxi-group category="taggedItemsTypes" title="Tagged Items" displayMode="texts"></dxi-group>
    </dxo-toolbox>

    <svg *dxTemplate="let item of 'customShapeTemplate'" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="#fff" stroke="#000" rx="8" ry="8" />

        <text x="60" y="20" text-anchor="middle" font-size="12" font-weight="bold" fill="#000">
            {{ item?.dataItem?.name || item?.text || 'Unnamed' }}
        </text>

        <text x="40" y="35" font-size="10" fill="blue" text-decoration="underline" style="cursor: pointer"
            (click)="editTaggedItem(item)">Edit</text>
        <text x="80" y="35" font-size="10" fill="red" text-decoration="underline" style="cursor: pointer"
            (click)="deleteTaggedItem(item)">Delete</text>
    </svg>
</dx-diagram>